import { render, staticRenderFns } from "./generic-popup.vue?vue&type=template&id=a9534ca8&"
import script from "./generic-popup.vue?vue&type=script&lang=js&"
export * from "./generic-popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports